import client from './client';
import { unwrapData } from './response';

export const listPayments = async (params = {}) => {
  const response = await client.get('/payments', { params });
  return unwrapData(response);
};

export const getPayment = async (id) => {
  const response = await client.get(`/payments/${id}`);
  return unwrapData(response, null);
};

export const getMercadoPagoSettings = async () => {
  const response = await client.get('/payments/mercado-pago/settings');
  return unwrapData(response, null);
};
